import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentLabAssignment on LabAssignment {
    id
    spaceRecordLookup
    roomTypeId
  }
`
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentLabAssignmentFragment,
  ents.extra.space.Record.LabAssignment
>({
  id: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    ents.extra.space.Record.LabAssignment.Id.isId,
  ),
  roomTypeId: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    ents.extra.space.RoomType.Id.isId,
  ),
  spaceRecordLookup: graphql.transformers.OUT.default(
    graphql.transformers.OUT.validate(
      graphql.transformers.OUT.json(),
      ents.extra.space.Record.EntitiesLookup.WithName.assertIsWithName,
    ),
    {},
  ),
})
